module.exports = __webpack_public_path__ + "static/news-d0b57ea490884414220e3f3c214c13bd.png";